import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

export default function DialogClienteAcordoMaterial({
  open,
  onClose,
  PaperComponent,
  editando,
  form,
  setForm,
  clientesCombo,
  fabricantesCombo,
  clienteInput,
  setClienteInput,
  fabricanteInput,
  setFabricanteInput,
  clienteLabel,
  fabricanteLabel,
  carregarClientesCombo,
  carregarFabricantesCombo,
  guardar,
  abrirMateriais,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth PaperComponent={PaperComponent}>
      <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
        {editando ? "Editar desconto adicional" : "Novo desconto adicional"}
      </DialogTitle>

      <DialogContent>
        <MDBox display="grid" gap={1.5} mt={1}>
          <div>
            <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Cliente</div>
            <Autocomplete
              size="small"
              options={clientesCombo}
              filterOptions={(x) => x}
              inputValue={clienteInput}
              getOptionLabel={clienteLabel}
              value={clientesCombo.find((c) => c.ref === form.refcliente) || null}
              onInputChange={(_, value, reason) => {
                if (reason === "input") {
                  setClienteInput(value);
                  setForm((p) => ({ ...p, refcliente: "" }));
                  carregarClientesCombo(value);
                }
                if (reason === "clear") {
                  setClienteInput("");
                  setForm((p) => ({ ...p, refcliente: "" }));
                }
              }}
              onChange={(_, value) => {
                setForm((p) => ({ ...p, refcliente: value?.ref || "" }));
                setClienteInput(value ? clienteLabel(value) : "");
              }}
              renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
            />
          </div>

          <div>
            <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Fabricante</div>
            <Autocomplete
              size="small"
              options={fabricantesCombo}
              filterOptions={(x) => x}
              inputValue={fabricanteInput}
              getOptionLabel={fabricanteLabel}
              value={fabricantesCombo.find((f) => f.ref === form.reffabricante) || null}
              onInputChange={(_, value, reason) => {
                if (reason === "input") {
                  setFabricanteInput(value);
                  setForm((p) => ({ ...p, reffabricante: "" }));
                  carregarFabricantesCombo(value);
                }
                if (reason === "clear") {
                  setFabricanteInput("");
                  setForm((p) => ({ ...p, reffabricante: "" }));
                }
              }}
              onChange={(_, value) => {
                setForm((p) => ({ ...p, reffabricante: value?.ref || "" }));
                setFabricanteInput(value ? fabricanteLabel(value) : "");
              }}
              renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
            />
          </div>

          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 1fr" }} gap={1.5}>
            <select
              title="Tipo de desconto"
              value={form.tipodesconto}
              onChange={(e) => setForm((p) => ({ ...p, tipodesconto: e.target.value, valor: "" }))}
              style={{
                height: 44,
                padding: "0 12px",
                borderRadius: 6,
                border: "1px solid #d2d6da",
                width: "100%",
                marginTop: 1,
                fontSize: 14,
                background: "#fff",
              }}
            >
              <option value="PERCENTAGEM">Percentagem</option>
              <option value="VALOR">Valor em euros</option>
            </select>

            <MDInput
              type="number"
              placeholder={form.tipodesconto === "PERCENTAGEM" ? "Valor %" : "Valor €"}
              value={form.valor}
              onChange={(e) => setForm((p) => ({ ...p, valor: e.target.value }))}
              fullWidth
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={Number(form.utilizacao_unica || 0) === 1}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, utilizacao_unica: e.target.checked ? 1 : 0 }))
                  }
                  size="small"
                />
              }
              label="Utilização única"
            />
          </MDBox>

          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5}>
            <MDInput
              label="Suporte JF %"
              type="number"
              value={form.suporte_jf_perc}
              onChange={(e) => {
                const jf = Number(e.target.value || 0);
                setForm((p) => ({
                  ...p,
                  suporte_jf_perc: e.target.value,
                  suporte_fabricante_perc: 100 - jf,
                }));
              }}
              fullWidth
            />

            <MDInput
              label="Suporte fabricante %"
              type="number"
              value={form.suporte_fabricante_perc}
              onChange={(e) => {
                const fab = Number(e.target.value || 0);
                setForm((p) => ({
                  ...p,
                  suporte_fabricante_perc: e.target.value,
                  suporte_jf_perc: 100 - fab,
                }));
              }}
              fullWidth
            />
          </MDBox>

          {Number(form.utilizacao_unica || 0) !== 1 && (
            <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5}>
              <MDInput
                label="Data inicial"
                type="date"
                value={form.datainicial}
                onChange={(e) => setForm((p) => ({ ...p, datainicial: e.target.value }))}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              <MDInput
                label="Data final"
                type="date"
                value={form.datafinal}
                onChange={(e) => setForm((p) => ({ ...p, datafinal: e.target.value }))}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
          )}

          <MDInput
            label="Observações"
            value={form.obs}
            onChange={(e) => setForm((p) => ({ ...p, obs: e.target.value }))}
            fullWidth
            multiline
            rows={3}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={Number(form.inativo || 0) === 1}
                onChange={(e) =>
                  setForm((p) => ({
                    ...p,
                    inativo: e.target.checked ? 1 : 0,
                  }))
                }
                size="small"
              />
            }
            label="Inativo"
          />
        </MDBox>
      </DialogContent>

      <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
        {editando && (
          <MDButton color="info" onClick={abrirMateriais}>
            Materiais do acordo
          </MDButton>
        )}

        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="success" onClick={guardar}>
          Gravar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
